import { h, render } from "preact";
import DirectShareDialog from "../components/DirectShareDialog.jsx";

/**
 * Makes a share button open up a small "share via"-Dialog
 * @param id Id of button 
 * @param items Items to share. Enum: "copy", "email"
 * 
 * @example
   <button id="share-button" role="button" class="button button--text">Share</button>
   <script>
     init("shareButton", {id: "share-button", items: ['copy'], copyText: "https://example.com"})
   </script>
 */
export default function initLightbox({
  copyText,
  id,
  items,
  mailBody,
  mailSubject,
}) {
  const button = document.getElementById(id);
  button.addEventListener("click", function (event) {
    event.preventDefault();
    openDialog();
  });
  let container;

  function openDialog() {
    container = document.createElement("div");
    button.after(container);
    render(
      <DirectShareDialog
        id={`dialog-for-${id}`}
        trigger={button}
        items={items}
        copyText={copyText || window.location.href}
        mailBody={mailBody || window.location.href}
        mailSubject={mailSubject}
        onClose={handleClose}
      />,
      container
    );
  }

  function handleClose() {
    container.parentNode.removeChild(container);
  }
}
